import { FileInput, Image, Paper, Stack, Textarea, TextInput, Title } from "@mantine/core";

interface ArticleInfoFormProps {
  title: string;
  author: string;
  excerpt: string;
  tags: string;
  featuredImageFile: File | null;
  imagePreview: string;
  onTitleChange: (value: string) => void;
  onAuthorChange: (value: string) => void;
  onExcerptChange: (value: string) => void;
  onTagsChange: (value: string) => void;
  onFeaturedImageChange: (file: File | null) => void;
}

export function ArticleInfoForm({
  title,
  author,
  excerpt,
  tags,
  featuredImageFile,
  imagePreview,
  onTitleChange,
  onAuthorChange,
  onExcerptChange,
  onTagsChange,
  onFeaturedImageChange,
}: ArticleInfoFormProps) {
  return (
    <Paper withBorder radius="md" p="lg">
      <Stack gap="md">
        <Title order={3}>Article Info</Title>
        <TextInput
          label="Title"
          placeholder="Enter the article title"
          value={title}
          onChange={(event) => onTitleChange(event.currentTarget.value)}
        />
        <TextInput
          label="Author"
          placeholder="Author name"
          value={author}
          onChange={(event) => onAuthorChange(event.currentTarget.value)}
        />
        <TextInput
          label="Tags"
          placeholder="Comma separated tags"
          value={tags}
          onChange={(event) => onTagsChange(event.currentTarget.value)}
        />
        <Textarea
          label="Excerpt"
          placeholder="Write a short summary"
          minRows={2}
          value={excerpt}
          onChange={(event) => onExcerptChange(event.currentTarget.value)}
        />
        <FileInput
          label="Featured image"
          placeholder="Upload an image"
          accept="image/*"
          value={featuredImageFile}
          onChange={onFeaturedImageChange}
        />
        {imagePreview && (
          <Image src={imagePreview} alt="Featured preview" radius="md" height={240} fit="cover" />
        )}
      </Stack>
    </Paper>
  );
}
